import React from "react";

import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import EOOS1 from "../../images/EOOS/EOOS1.png";
import EOOS2 from "../../images/EOOS/EOOS2.png";
import EOOS3 from "../../images/EOOS/EOOS3.png";
import EOOS4 from "../../images/EOOS/EOOS4.png";
import EOOS5 from "../../images/EOOS/EOOS5.png";
import EOOS6 from "../../images/EOOS/EOOS6.png";

import { Link } from "react-router-dom";

const EOOSCourses = () => {
  return (
    <div className="QL__EOOSCourses__BG">
      <Container>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Link
              style={{ textDecoration: "none" }}
              to="/courses/quranwithtajweed"
            >
              <Card
                className="QL__EOOSCourses__cards"
                sx={{ minWidth: 275 }}
                justifyContent="center"
              >
                <CardContent>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    <img src={EOOS1} alt="image" />
                  </Typography>

                  <br />
                  <Typography
                    sx={{ mb: -1.5 }}
                    variant="h5"
                    justifyContent="center"
                    fontWeight={600}
                  >
                    Qur'an Reading With Tajweed
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Link
              style={{ textDecoration: "none" }}
              to="/courses/qurantranslation"
            >
              <Card
                className="QL__EOOSCourses__cards"
                sx={{ minWidth: 275 }}
                justifyContent="center"
              >
                <CardContent>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    <img src={EOOS2} alt="image" />
                  </Typography>
                  <br />
                  <Typography variant="h5" fontWeight={600}>
                    Qur'an Translation
                    <br />
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Link
              style={{ textDecoration: "none" }}
              to="/courses/basicquranreading"
            >
              <Card
                className="QL__EOOSCourses__cards"
                sx={{ minWidth: 275 }}
                justifyContent="center"
              >
                <CardContent>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    <img src={EOOS3} alt="image" />
                  </Typography>

                  <br />

                  <Typography variant="h5" fontWeight={600}>
                    Basic Qur'an Reading
                    <br />
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Link
              style={{ textDecoration: "none" }}
              to="/courses/learntenqirat"
            >
              <Card
                className="QL__EOOSCourses__cards"
                sx={{ minWidth: 275 }}
                justifyContent="center"
              >
                <CardContent>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    <img src={EOOS4} alt="image" />
                  </Typography>
                  <br />
                  <Typography variant="h5" fontWeight={600}  sx={{ mt:0.6}}>
                    Learn Ten Qirats
                    <br />
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Link
              style={{ textDecoration: "none" }}
              to="/courses/quranmemorization"
            >
              <Card
                className="QL__EOOSCourses__cards"
                sx={{ minWidth: 275 }}
                justifyContent="center"
              >
                <CardContent>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    <img src={EOOS5} alt="image" />
                  </Typography>

                  <br />

                  <Typography variant="h5" fontWeight={600}  sx={{ mt:0.6}}>
                    Qur'an Memorization
                    <br />
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Link
              style={{ textDecoration: "none" }}
              to="/courses/basicislamicknowledge"
            >
              <Card
                className="QL__EOOSCourses__cards"
                sx={{ minWidth: 275 }}
                justifyContent="center"
              >
                <CardContent>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    <img src={EOOS6} alt="image" />
                  </Typography>
                  <br />
                  <Typography variant="h5" fontWeight={600}>
                    Basic Islamic Knowledge
                    <br />
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default EOOSCourses;
